import { heroStats } from "@/mocks/dramaData";

export default function Hero() {
  return (
    <section id="top" className="relative flex w-full flex-col items-center overflow-hidden bg-foreground-950 text-background-50">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Abstract%20entertainment%20concept%20with%20glowing%20popcorn%20and%20spotlight%20beams%2C%20warm%20orange%2C%20rose%20and%20gold%20gradient%20vibe%2C%20noise%20and%20grain%20texture%2C%20modern%20editorial%20illustration%2C%20dark%20background%20with%20vibrant%20accents&width=1600&height=900&seq=hero-gossip-2026&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950/85"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-20 md:pt-40">
        <span className="mb-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500/15 px-4 py-1.5 text-xs font-semibold tracking-wide text-accent-200 ring-1 ring-accent-400/40 backdrop-blur">
          <i className="ri-sparkling-2-fill"></i>
          本月大瓜合集 · 总览 · 盘点 · 榜单 持续更新中
        </span>

        <h1 className="font-brand text-4xl leading-tight text-background-50 sm:text-5xl md:text-6xl">
          本月大瓜，一次吃个明白
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
          从影视到综艺、从音乐到商业体坛，聚合本月最火的话题事件与热搜动态，用
          <strong className="mx-1 font-semibold text-accent-300">总览 + 榜单 + 分类 + 时间轴</strong>
          帮你快速掌握本月大瓜盘点全貌，不用再到处翻找零散爆料。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#feed"
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 shadow-lg shadow-primary-900/30 transition hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-line"></i>
            开始吃瓜
          </a>
          <a
            href="#rank"
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-100 ring-1 ring-background-200/40 backdrop-blur transition hover:bg-background-50/20 sm:w-auto"
          >
            查看热度榜单 <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <div className="mt-12 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center rounded-2xl border border-background-200/20 bg-background-50/[0.06] px-3 py-4 backdrop-blur"
            >
              <p className="font-brand text-2xl text-accent-300 md:text-3xl">
                {s.value}
                <span className="ml-0.5 text-base text-background-200">{s.unit}</span>
              </p>
              <p className="mt-1 text-xs text-background-200/90 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}